import { CoreGraphNode } from "../../../core/graph/CoreGraphNode";
export class BaseCopyStamp extends CoreGraphNode {
  constructor(scene) {
    super(scene, "CopyStamp");
    this._globalIndex = 0;
  }
  reset() {
    this.setGlobalIndex(0);
  }
  setGlobalIndex(index) {
    const oldIndex = this._globalIndex;
    this._globalIndex = index;
    if (oldIndex != this._globalIndex) {
      this.setDirty();
      this.removeDirtyState();
    }
  }
  value(attribName) {
    return this._globalIndex;
  }
}
